// Servicios de API para Labs
// Lee variables de entorno tanto para Vite (VITE_*) como para CRA (REACT_APP_*)
const env = (typeof import.meta !== 'undefined' && import.meta.env) || {};
const processEnv = (typeof process !== 'undefined' && process.env) || {};

// Detectar si estamos en producción
const isProduction = typeof window !== 'undefined' && 
                     window.location.hostname !== 'localhost' && 
                     window.location.hostname !== '127.0.0.1';

// Fallback explícito para producción (Render)
const PROD_API_BASE = 'https://backend-url-security-analyzer.onrender.com/api';

// Configurar API_BASE_URL (prioridad: Vite -> CRA -> fallback prod -> heurística)
let API_BASE_URL = env.VITE_API_BASE_URL ||
                   env.VITE_API_URL ||
                   processEnv.REACT_APP_API_BASE_URL ||
                   processEnv.REACT_APP_API_URL ||
                   (isProduction ? PROD_API_BASE : null) ||
                   (isProduction 
                     ? (window.location.protocol + '//' + window.location.host.replace('frontend-', 'backend-') + '/api')
                     : 'http://localhost:5000/api');

// Evitar apuntar al dominio del frontend en producción
if (isProduction) {
  const frontendHost = window.location.hostname;
  const looksLikeFrontend = API_BASE_URL?.includes(frontendHost);
  if (looksLikeFrontend) {
    API_BASE_URL = PROD_API_BASE;
  }
}

console.log('🔧 Labs API_BASE_URL:', API_BASE_URL);

export const labsAPI = {
  // Rutas
  async getRoutes() {
    try {
      console.log('🚀 Fetching routes from:', `${API_BASE_URL}/labs`);
      const res = await fetch(`${API_BASE_URL}/labs`);
      console.log('📡 Response status:', res.status, res.statusText);
      
      if (!res.ok) {
        const errorText = await res.text().catch(() => 'Unknown error');
        console.error('❌ Error response:', errorText);
        throw new Error(`Error ${res.status}: ${errorText || res.statusText}`);
      }
      
      const data = await res.json();
      console.log('✅ Routes fetched successfully:', data?.length || 0, 'routes');
      return data;
    } catch (error) {
      console.error('❌ Failed to fetch routes:', error);
      throw error;
    }
  },

  async getRoute(routeId) {
    const res = await fetch(`${API_BASE_URL}/labs/${routeId}`);
    if (!res.ok) throw new Error('Error obteniendo ruta');
    return res.json();
  },

  // Progreso del usuario
  async getUserProgress() {
    const res = await fetch(`${API_BASE_URL}/user/labs/progress`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
      },
    });
    if (!res.ok) throw new Error('Error obteniendo progreso');
    return res.json();
  },

  async getUserAchievements() {
    const res = await fetch(`${API_BASE_URL}/user/labs/achievements`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
      },
    });
    if (!res.ok) throw new Error('Error obteniendo logros');
    return res.json();
  },

  // Completar nivel
  async completeLevel(routeId, levelId, flag) {
    const res = await fetch(`${API_BASE_URL}/labs/${routeId}/${levelId}/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
      },
      body: JSON.stringify({ flag }),
    });
    if (!res.ok) {
      const error = await res.json().catch(() => ({ error: 'Error completando nivel' }));
      throw new Error(error.error || error.message || 'Error completando nivel');
    }
    return res.json();
  },

  // Pistas
  async getHint(routeId, levelId, hintIndex) {
    const res = await fetch(
      `${API_BASE_URL}/labs/${routeId}/${levelId}/hint/${hintIndex}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
        },
      }
    );
    if (!res.ok) throw new Error('Error obteniendo pista');
    return res.json();
  },

  // Estadísticas
  async getUserStats() {
    const res = await fetch(`${API_BASE_URL}/user/labs/stats`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
      },
    });
    if (!res.ok) throw new Error('Error obteniendo estadísticas');
    return res.json();
  },

  // Certificado
  async generateCertificate(routeId) {
    const res = await fetch(
      `${API_BASE_URL}/labs/${routeId}/certificate`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
        },
      }
    );
    if (!res.ok) throw new Error('Error generando certificado');
    return res.blob();
  },

  // Descargar certificado
  async downloadCertificate(routeId) {
    const blob = await this.generateCertificate(routeId);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `certificado-${routeId}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },
};
